import React from "react";
import FontAwesome, { type FontAwesomeProps } from "react-fontawesome";
import { Icon, IconLoading, type IconProps } from "../Icon";
import { IconMapping } from "../Icon/Icon.mapping";
import type { ButtonProps } from "./types";

export const getIcon = (
  icon?: IconProps["variant"] | FontAwesomeProps["name"],
  opts?: {
    isBusy?: ButtonProps["isBusy"];
    iconComponentProps?: ButtonProps["iconProps"];
  }
) => {
  if (opts?.isBusy) {
    return <IconLoading speed="fast" />;
  }

  if (!icon) return null;

  return Object.hasOwn(IconMapping, icon) ? (
    <Icon
      variant={icon as IconProps["variant"]}
      {...(opts?.iconComponentProps ?? {})}
    />
  ) : (
    // IMPROVE: deprecate font awesome usage with Ops Hub deprecation
    <FontAwesome name={icon} />
  );
};
